@let state = leakState();

<svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 36 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0">
  <path d="M2.27539 11.0001C3.65913 8.608 5.57753 6.56393 7.86719 5.03125"
        [attr.stroke]="state.level >= 1 ? state.color : defaultColor"
        stroke-width="4" stroke-linecap="round"/>

  <path d="M12.8672 2.70357C14.4547 2.24547 16.1323 2 17.8673 2C19.6022 2 21.2798 2.24544 22.8672 2.7035"
        [attr.stroke]="state.level >= 2 ? state.color : defaultColor"
        stroke-width="4" stroke-linecap="round"/>

  <path d="M33.4592 11C32.0754 8.60784 30.157 6.5637 27.8672 5.03101"
        [attr.stroke]="state.level >= 3 ? state.color : defaultColor"
        stroke-width="4" stroke-linecap="round"/>
</svg>
